/* Related products via the Product Recommendations API. Loaded by sections/related-products.liquid. */
(function () {
  'use strict';

  var doc = document;
  var $ = function (sel, root) { return (root || doc).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || doc).querySelectorAll(sel)); };

  /* ---------- Related products (Product Recommendations API) ---------- */
  function initRelated() {
    var el = $('[data-related-products]');
    if (!el || !el.getAttribute('data-url')) return;
    fetch(el.getAttribute('data-url'))
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        if (!html) return;
        var tmp = doc.createElement('div');
        tmp.innerHTML = html;
        var fresh = tmp.querySelector('[data-related-products]');
        if (fresh && fresh.querySelector('.product-card')) {
          el.innerHTML = fresh.innerHTML;
          el.style.display = '';
        } else {
          el.style.display = 'none';
        }
      })
      .catch(function () { el.style.display = 'none'; });
  }

  window.theme.register(function (root) {
    if (root === doc || root.querySelector('[data-related-products]')) initRelated();
  });
})();
